import React, { useState } from 'react';

import { Box, Card, Grid } from '@mui/material';

import SocialNetworkField from './SocialNetworkField';
import Text from 'components/Text';

interface SocialNetwork {
  type: string;
  username: string;
}

interface SocialNetworkFieldsProps {
  networkTypes: string[];
  onSave?: (networks: SocialNetwork[]) => void;
}

const formatType = (type: string) => type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

const SocialNetworkFields: React.FC<SocialNetworkFieldsProps> = ({ networkTypes, onSave }) => {
  const [networks, setNetworks] = useState<SocialNetwork[]>([]);

  const handleNetworkChange = (type: string, username: string) => {
    const updatedNetworks = [...networks];
    const existingIndex = updatedNetworks.findIndex(n => n.type === type);

    if (existingIndex >= 0) {
      updatedNetworks[existingIndex] = { type, username };
    } else {
      updatedNetworks.push({ type, username });
    }

    setNetworks(updatedNetworks);
    onSave?.(updatedNetworks);
  };

  return (
    <Grid container spacing={2}>
      {networkTypes.map((type: string) => (
        <Grid item xs={12} sm={6} key={type}>
          <Card sx={{ borderRadius: 2 }}>
            <Text color="textPrimary" bold>{`Perfil no ${formatType(type)}`}</Text>
            <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
              <Text
                color="textPrimary"
                opacity={0.8}
              >{`www.${formatType(type).toLowerCase()}.com/`}</Text>
              <SocialNetworkField
                socialNetworkType={type}
                placeholder={formatType(type)}
                onChange={username => handleNetworkChange(type, username)}
              />
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default SocialNetworkFields;
